/**
 * Gallery product filter — mobile disclosure (matches FAQ TOC toggle).
 */
(function () {
  function initGalleryFilterDropdown(root) {
    const toggle = root.querySelector('[data-ez-gallery-filter-toggle]');
    const panel = root.querySelector('[data-ez-gallery-filter-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      const open = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.classList.toggle('is-collapsed', open);
    });
  }

  function init() {
    document.querySelectorAll('[data-ez-gallery-filter-dropdown]').forEach(initGalleryFilterDropdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
